import { Link, useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { GraduationCap } from "lucide-react";
import { AdminLoginForm } from "../components/auth";
import SharedHeader from "@/components/SharedHeader";
import SharedFooter from "@/components/SharedFooter";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  
  const handleBack = () => {
    // Redirect to main site using current origin
    window.location.href = window.location.origin + "/";
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex flex-col">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md border-b border-slate-100">
        <SharedHeader transparent={true} />
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-6 py-8">
        <Card className="w-full max-w-md shadow-xl bg-white">
          <CardContent className="p-6 sm:p-8">
            <AdminLoginForm onBack={handleBack} portal="admin" redirectTo="/admin/dashboard" title="Admin Login" subtitle="Access the admin dashboard" />
          </CardContent>
        </Card>
      </main>

      {/* Footer */}
      <SharedFooter />
    </div>
  );
}
